module.exports = __webpack_public_path__ + "static/media/SAFETY_GOGGLE_BYMEDO_2105_stp011101.60392de9.png";